import {
	throwTranslatableError,
} from '@/core';
import {
	getOrdersByStringFilterRequest,
} from '../requests';

async function getOrdersByStringFilter({ commit }, filterString) {
	try {
		let res = await getOrdersByStringFilterRequest({ filterString });
		commit('setOrders', res);
		return res;
	} catch (err) {
		console.error(err);
		throwTranslatableError(err, 'orderFetchFailed');
	}
	return false;
}

export default {
	getOrdersByStringFilter,
};
